// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 222) return "static/chunks/vendors.sravni-149d850a3ac8ba93.js";
	if (chunkId === 893) return "static/chunks/893-58ed2ecf7c5664f3.js";
	if (chunkId === 300) return "static/chunks/300-24a8e4da868976f7.js";
	if (chunkId === 928) return "static/chunks/928-516c130e3714d8a5.js";
	if (chunkId === 637) return "static/chunks/637-dd102f99d90dd5dc.js";
	if (chunkId === 832) return "static/chunks/832-5372c397c6d44fc1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","987":"react-lottie"}[chunkId] || chunkId) + "." + {"203":"f6474b468c85406a","296":"708e47fd560a6f87","458":"a09e67115307c7a0","548":"124e9fbb6c3daf70","562":"ec6e2ace869d3930","606":"b917aced665c6b54","987":"932b9eecaffb4c28"}[chunkId] + ".js";
};